import React from 'react';
import classnames from 'classnames';
import { compose, withPropsOnChange } from 'recompose';
import { sortByWeight } from '../helpers/array';
import { replaceSpaceWith } from '../pages/question/helpers/prettify-name';
import { stringToWrappedText } from '../helpers/formatters/string-format';
import styles from '../styles/components/advert.module.scss';
import { DigitalCoachAction } from '../widgets/digital-coach-widget';
import { renderAsCard } from './card';
import { PurifiedHtmlContainer } from './layout/purified-html-container';
import { Image } from './images/image';

const Component = React.memo(({ title, titleAs = 'h2', body, foregroundImageUrl, inlineImageUrl, actions }) => (
  <>
    {foregroundImageUrl && <Image className={styles.image} src={foregroundImageUrl} title={title} />}
    <section className={styles['content-container']}>
      {title && (
        <div className={styles.header}>
          <PurifiedHtmlContainer renderAs={titleAs} className={styles.title} html={title} />
        </div>
      )}
      {inlineImageUrl && <Image className={styles['inline-image']} src={inlineImageUrl} title={title} />}
      {body && (
        <div className={classnames(styles.body, 'typography')}>
          <PurifiedHtmlContainer renderAs='div' className={styles.paragraphs} html={stringToWrappedText(body, 'p')} />
        </div>
      )}
      {actions.length > 0 && (
        <div className={styles.footer}>
          {actions.map((action, index) => (
            <DigitalCoachAction key={index} {...action} />
          ))}
        </div>
      )}
    </section>
  </>
));

Component.displayName = 'AdvertLinkComponent';

export const AdvertLink = compose(
  withPropsOnChange(['className', 'styling'], ({ className, styling }) => {
    const themeClass = styling && replaceSpaceWith(styling, '-');

    return {
      className: classnames({ [styles[themeClass]]: themeClass }, styles.container, className)
    };
  }),
  withPropsOnChange(['backgroundImageUrl'], ({ backgroundImageUrl }) => ({
    style: { backgroundImage: `url(${backgroundImageUrl})` }
  })),
  withPropsOnChange(['actions'], ({ actions = [] }) => ({
    actions: sortByWeight(actions)
  })),
  renderAsCard
)(Component);

AdvertLink.displayName = 'AdvertLinkWidget';
